import React from "react";
import { Modal } from "react-bootstrap";

const RejectDialog = ({
  isRejectDialogOpen,
  setIsRejectDialogOpen,
  handleDeleteConfirm,
  message,
}) => {
  return (
    <Modal
      show={isRejectDialogOpen}
      onHide={() => setIsRejectDialogOpen(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || "Are you sure you want to delete this item?"}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setIsRejectDialogOpen(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            handleDeleteConfirm();
            setIsRejectDialogOpen(false);
          }}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectDialog;
